import { create } from "zustand";
import { persist } from "zustand/middleware";

export type Theme = "light" | "dark" | "system";

interface ThemeState {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

const prefersDarkMedia =
  typeof window !== "undefined" ? window.matchMedia("(prefers-color-scheme: dark)") : null;

function applyTheme(theme: Theme) {
  if (typeof document === "undefined") return;
  const isDark = theme === "dark" || (theme === "system" && !!prefersDarkMedia?.matches);
  document.documentElement.classList.toggle("dark", isDark);
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: "system",
      setTheme: (theme) => {
        set({ theme });
        applyTheme(theme);
      },
    }),
    {
      name: "ogma-license-theme",
      onRehydrateStorage: () => (state) => {
        if (state) applyTheme(state.theme);
      },
    },
  ),
);

// Re-applies the resolved theme whenever the OS preference flips, but only
// while the user is on "system" — an explicit light/dark choice must stick.
prefersDarkMedia?.addEventListener("change", () => {
  if (useThemeStore.getState().theme === "system") applyTheme("system");
});
